import { useGoogleOneTap as _useGoogleOneTap } from '#bubba/shared/composables/auth/useGoogleOneTap';

export function useGoogleOneTap(callbackPath = '/account') {
  return _useGoogleOneTap(callbackPath);
}
